// ** I18n Imports
import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n

  // Enables the i18next backend
  .use(Backend)

  // Enable automatic language detection
  .use(LanguageDetector)

  // Enables the hook initialization module
  .use(initReactI18next)
  .init({
    // lng: 'en',
    backend: {
      /**
       * ⚠⚠ THE VERSION QUERY IS LOAD-BEARING - without it, new strings appear to users as RAW
       * KEY NAMES.
       *
       * The JS bundle is cache-busted by filename on every build, so code always refreshes. This
       * file is NOT: it is one fixed URL, so a browser holds its copy indefinitely. Add a string
       * to en.json, deploy, and anyone with the old file cached gets no entry for the new key -
       * and i18next prints the key itself.
       *
       * ⭐ Yael, 2026-10-08, on the expired-visit card: the screen read
       * "visit.visit_expired_title" / "visit.visit_expired_body". The SERVER was serving the right
       * text - fetched and confirmed - her browser simply had the old file.
       *
       * ⚠ Care partners are external users. They will never think to hard-refresh, and they are
       * exactly the people who see these screens.
       *
       * REACT_APP_BUILD_ID is set by the `build` script in package.json, so it changes on every
       * production build. The Date.now() fallback covers `npm start`, where no build id exists -
       * it re-fetches each load, which is correct for development.
       */
      loadPath: `/assets/data/locales/{{lng}}.json?v=${process.env.REACT_APP_BUILD_ID || Date.now()}`
    },
    fallbackLng: 'en',
    // LanguageDetector reports the BROWSER's full tag - 'en-US', not 'en'. Without this,
    // i18n.language is 'en-US' and three things break at once (2026-09-02):
    //   1. IntlDropdown matched i18n.language === 'en' exactly, so it fell through and
    //      passed "en-US" to ReactCountryFlag as a country code -> broken image icon.
    //   2. langObj['en-US'] is undefined -> the language name beside the flag was blank.
    //   3. loadPath requests /assets/data/locales/en-US.json, which does not exist (only
    //      de/en/fr/pt do). Every load 404s and survives only via fallbackLng.
    // 'languageOnly' loads 'en' for 'en-US', 'he' for 'he-IL', and so on.
    load: 'languageOnly',
    debug: false,
    // keySeparator: false,
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    }
  }).then((e) => {
    // console.log("e", e)
  })

export default i18n
